import React, { useState } from "react";
import LiveLotsStatus from "./LiveLotsStatus";
import ProductLiveLotInfo from "../children/ProductLiveLotInfo";
import ProductLiveUpdatingArea from "../children/ProductLiveUpdatingArea";
import ReverseLiveBididngHistory from "../table/ReverseLiveBididngHistory";

function ProductLiveLotsDetails({ liveOfferData, singleAuctionData, index }) {
  const [veiwBidDetails, setVeiwBidDetails] = useState(false);
  const [bidderDetails, setBidderDetails] = useState([]);
  return (
    <>
      <div
        className="liveLots pin-top"
        style={{
          border: "1px solid black",
          borderRadius: "12px 0px 12px 12px",
        }}
      >
        <div>{index}</div>
        <div
          style={{
            backgroundColor: "#fcf1ff",
            borderRadius: "12px 0px 12px 12px",
          }}
        >
          <ProductLiveLotInfo liveOfferData={liveOfferData} />
          <hr className="black" style={{ height: "0.5px" }} />
          <ProductLiveUpdatingArea
            liveOfferData={liveOfferData}
            veiwBidDetails={veiwBidDetails}
            setVeiwBidDetails={setVeiwBidDetails}
            setBidderDetails={setBidderDetails}
            singleAuctionData={singleAuctionData}
          />
        </div>
        <LiveLotsStatus
          singleAuctionData={singleAuctionData}
          item={liveOfferData}
        />
      </div>
      {veiwBidDetails && (
        <ReverseLiveBididngHistory bidderDetails={bidderDetails} />
      )}
    </>
  );
}

export default ProductLiveLotsDetails;
